import { render, staticRenderFns } from "./IndustryTargeting.vue?vue&type=template&id=7a949a45&"
import script from "./IndustryTargeting.vue?vue&type=script&lang=ts&"
export * from "./IndustryTargeting.vue?vue&type=script&lang=ts&"
import style0 from "./IndustryTargeting.vue?vue&type=style&index=0&id=7a949a45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports